import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { StateService, TransitionService } from '@uirouter/angular';
import { NAV_STATES } from '../nav.states';

@Component({
    selector: 'glxy-nav-header',
    templateUrl: './nav-header.component.html',
    styleUrls: ['./nav-header.component.scss']
})
export class NavHeaderComponent implements OnInit {
    @Input() isFreeUser = false;
    @Input() isTrialUser = false;
    @Input() isCorporateUser = false;
    @Input() isAdmin = false;
    @Input() isPlatformUser = false;
    @Input() isNavOpen = true;
    @Input() isMSTeams = false;
    @Output() onToggleNavPanel = new EventEmitter<boolean>();
    public title = 'CalendarHero';
    public showBillingLink = true;
    public showUpgradeBtn = false;

    constructor(private $state: StateService, private transitionService: TransitionService) {}

    ngOnInit() {
        const isTeamNonAdmin = !this.isAdmin && this.isCorporateUser;
        this.showBillingLink = !this.isPlatformUser && !isTeamNonAdmin;
        this.showUpgradeBtn = this.isFreeUser || this.isTrialUser;

        // sets title on app load
        this.title = NAV_STATES[this.$state.$current.name] || 'CalendarHero';

        // sets title for any future transitions
        this.transitionService.onSuccess({}, (transition) => {
            const to = transition.to();
            const stateName = to?.name || '';
            this.title = NAV_STATES[stateName] || 'CalendarHero';
        });
    }

    public handleToggleNavPanel() {
        this.onToggleNavPanel.emit(!this.isNavOpen);
    }

    public goTo(state: string, params?) {
        this.$state.go(state, params || {});
    }

    public openTab(url: string) {
        window.open(url, '_blank');
    }
}
